export default function PHP_MySQLLimit() {
  return (
    <div>
      <h1>PHP_MySQLLimit</h1>
    </div>
  );
}
